import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

import DocPage from "../components/DocPage.vue";
import { useLocalePath } from "../composables/useLocalePath";


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

const lp = useLocalePath();

const sections = [
  { key: "what", paras: 2 },
  { key: "how", paras: 3 },
  { key: "product", paras: 1 },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(DocPage, {
    title: _ctx.$t('pages.about.title'),
    lede: _ctx.$t('pages.about.lede')
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (s) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: s.key
        }, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(`pages.about.${s.key}.title`)), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.paras, (n) => {
            return (_openBlock(), _createElementBlock("p", { key: n }, _toDisplayString(_ctx.$t(`pages.about.${s.key}.p${n}`)), 1))
          }), 128))
        ], 64))
      }), 64)),
      _createElementVNode("p", null, [
        _createVNode(_component_router_link, {
          to: _unref(lp)('/connectera')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("pages.about.product.link")), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _: 1
  }, 8, ["title", "lede"]))
}
}

})